/** You lives in `routes/you/` (one module per section); this file keeps the shared 404. */
import { Empty } from '../components/ui.js'

export function NotFound() {
  return <Empty title="Nothing here">That link does not point to anything in Viko.</Empty>
}
